import React from 'react'
import { Field, FormikProps } from 'formik'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { DropzoneInput } from '../../../../../../../components/inputs/DropzoneInput'
import { TextInput } from '../../../../../../../components/inputs/TextInput'
import { PlusIcon, TrashIcon } from '@heroicons/react/20/solid'
import { Button } from '../../../../../../../components/ui/button'

interface Props {
  formik: FormikProps<any>
}

export const TechnicalFormB1Ev2: React.FC<Props> = ({ formik }) => {
  return (
    <FormSectionTwoColumns
      sectionKey={'b1e'}
      title="e) informace o nutnosti povolení výjimky z požadavků na výstavbu"
      infoContent={
        <div className="text-left">
          <u>Informace o nutnosti povolení výjimky z požadavků na výstavbu</u>
          <br />
          <h3 className="font-bold mt-3">
            Příklady situací, kdy je nutné povolení výjimky z požadavků na výstavbu:
          </h3>
          <ol className="list-decimal ml-5">
            <li className="font-bold mt-3">
              Odchylky od územního plánu
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Stavba má přesahovat maximální povolenou výšku (např. navrhovaná budova má 11 m,
                  zatímco regulativ povoluje 9 m).
                </li>
                <li>Zastavěná plocha překračuje limit stanovený pro daný typ pozemku.</li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Výjimka je požadována pro zvýšení maximální výšky budovy o 2
                metry, aby bylo možné realizovat architektonické prvky fasády.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Minimální vzdálenosti od hranice pozemku
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Stavba nedodržuje minimální vzdálenost od sousedního pozemku nebo hranice pozemku
                  (např. místo 2 m je plánováno 1,5 m).
                </li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Pro plánovanou garáž je požadována výjimka z minimální vzdálenosti
                od hranice pozemku, která je snížena na 1,5 metru z důvodu omezených prostorových
                možností.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Ochranná a bezpečnostní pásma
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Umístění stavby v ochranném pásmu dopravní nebo technické infrastruktury (např.
                  plynové vedení, železnice).
                </li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Stavba zasahuje do ochranného pásma elektrického vedení; výjimka
                je požadována s doložením bezpečnostního posouzení.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Odchylky od stavebních technických norem
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Nedodržení požadované světlé výšky místností, počtu parkovacích míst nebo dalších
                  technických požadavků.
                </li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Výjimka je žádána pro snížení minimální světlé výšky podkroví z
                2,6 m na 2,4 m z důvodu zachování estetických proporcí střechy.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Minimální vzdálenosti od hranice pozemku
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Stavba nedodržuje minimální vzdálenost od sousedního pozemku nebo hranice pozemku
                  (např. místo 2 m je plánováno 1,5 m).
                </li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Pro plánovanou garáž je požadována výjimka z minimální vzdálenosti
                od hranice pozemku, která je snížena na 1,5 metru z důvodu omezených prostorových
                možností.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Zásahy do památkově chráněného území
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Stavba zasahuje do zóny památkové ochrany nebo kulturně významného území, kde
                  regulace vyžaduje specifické materiály, tvary nebo barvy.
                </li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Pro fasádu je požadována výjimka z památkových regulativů pro
                použití moderního omítkového materiálu, který však respektuje původní estetiku.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Požadavky na přístup a infrastrukturu
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Nedodržení podmínky připojení na veřejnou infrastrukturu, např. kanalizaci nebo
                  vodovod.
                </li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Výjimka je požadována pro zajištění odvodu odpadních vod pomocí
                individuální ČOV, protože v místě není dostupná centrální kanalizační síť.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Změna využití pozemku nebo objektu
              <ul className="list-disc ml-5 font-normal">
                <li>
                  Stavba na pozemku původně určeném k jinému účelu (např. zemědělský pozemek změněn
                  na stavební).
                </li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Výjimka je žádána pro změnu užívání zemědělského pozemku na
                stavební, protože pozemek již neplní zemědělskou funkci.“
              </div>
            </li>

            <li className="font-bold mt-3">
              Omezené přístupové komunikace
              <ul className="list-disc ml-5 font-normal">
                <li>Přístupová komunikace neodpovídá požadavkům na šířku nebo zatížitelnost.</li>
              </ul>
              <div className="font-normal mt-2">
                <b>Příklad: </b> „Výjimka je požadována pro snížení minimální šířky přístupové cesty
                z 3 m na 2,5 m z důvodu stísněných podmínek v terénu.“
              </div>
            </li>
          </ol>
          <div className="mt-5">
            Tyto výjimky se vždy schvalují příslušným stavebním úřadem na základě konkrétních
            podmínek a doložení nezbytných podkladů, například bezpečnostních posudků nebo
            technických analýz.
          </div>
        </div>
      }
    >
      <div className="mt-5 sm:col-span-6">
        {formik.values.b1e.issuedExceptions.map((exception: any, index: number) => {
          return (
            <div className="border rounded-md p-3 mb-3 relative" key={index}>
              <Button
                type="button"
                variant="secondary"
                size="xs"
                className="mr-2 absolute top-2 right-2"
                onClick={() => {
                  if (window.confirm('Skutečně smazat?')) {
                    return formik.setFieldValue(
                      'b1e.issuedExceptions',
                      formik.values.b1e.issuedExceptions.filter((_: any, i: number) => i !== index),
                    )
                  }
                }}
              >
                <TrashIcon className="h-4 inline text-gray-600" />
              </Button>
              <div className={`sm:col-span-6 mt-4`}>
                <Field
                  component={TextInput}
                  name={`b1e.issuedExceptions[${index}].name`}
                  label="Název výjimky"
                />
                <div className="mt-4">
                  <Field
                    component={RichTextInput}
                    name={`b1e.issuedExceptions[${index}].description`}
                    aiHint={`Popis výjimky ${formik.values?.b1e?.issuedExceptions[index]?.name}`}
                  />
                </div>
                <div className="mt-4">
                  <Field
                    component={DropzoneInput}
                    name={`b1e.issuedExceptions[${index}].files`}
                    label="Dokumenty"
                    fileLabel={`b1e - Výjimky ${exception.name ? ' - ' + exception.name : ''}`}
                  />
                </div>
              </div>
            </div>
          )
        })}
        <div className="flex justify-end">
          <Button
            type="button"
            onClick={() =>
              formik.setFieldValue('b1e.issuedExceptions', [
                ...formik.values.b1e.issuedExceptions,
                {},
              ])
            }
          >
            <PlusIcon className="h-6 inline" />
            Přidat výjimku
          </Button>
        </div>
      </div>
    </FormSectionTwoColumns>
  )
}
